import { render } from "./TooltipUserV2.vue?vue&type=template&id=412aab51&scoped=true"
import script from "./TooltipUserV2.vue?vue&type=script&lang=js"
export * from "./TooltipUserV2.vue?vue&type=script&lang=js"

import "./TooltipUserV2.vue?vue&type=style&index=0&id=412aab51&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412aab51"]])

export default __exports__